import { CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Namespace } from "../../locales/translations";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectAllBatches } from "../../store/reducers/batches/batch_reducer";
import StatisticsPage from "../StatisticsPage";
import CenteredBox from "../_include/CenteredBox";
import FilterChip from "../_include/Filters/FilterChip";
import BatchCardList from "./BatchCardList";
import KeyNumbersCard from "./KeyNumbersCard";
import { selectAllRfidBatches } from "../../store/reducers/batches/rfid_batch_reducer";
import { useParams } from "react-router-dom";
import { selectAllCampaignAddresses } from "../../store/reducers/awareness_campaigns/addresses";
import { AddressReportActions } from "../../store/reducers/awareness_campaigns/address_report";
import AddressReportModal from "../AwarenessCampaigns/AddressReport/AddressReportModal";

type BatchListContainerProps = {
    showStats?: boolean;
    onSeeMoreClick: () => void;

};

const BatchesList: React.FC<BatchListContainerProps> = ({ showStats, onSeeMoreClick }) => {
    const { t } = useTranslation([Namespace.ADDRESSES]);

    const dispatch = useAppDispatch();

    const hasAddresses = useAppSelector(state => state.address.ids.length > 0);
    const hasBatches = useAppSelector(state => selectAllBatches(state).length > 0 || selectAllRfidBatches(state).length > 0);
    const loading = useAppSelector(state => state.batch.list.loading || state.batch.rfid.loading);
    const { addressKey } = useParams<{ addressKey: string }>();
    const missionAddresses = useAppSelector(state => selectAllCampaignAddresses(state));
    const addressData = missionAddresses.find((address) => address.addressKey === addressKey!);
    const error = useAppSelector(state => state.batch.list.error || state.batch.rfid.error);
    const isExternalSource = addressData?.fromExternalSource;

    const handleOpenReport = () => {
        if (addressData) {
            dispatch(AddressReportActions.openReportForm(addressData));
        }
    };

    if (loading) {
        return (
            <CenteredBox>
                <CircularProgress />
            </CenteredBox>
        );
    }

    if (error) {
        return (
            <CenteredBox>
                <Typography variant="body2" color="error">{error}</Typography>
            </CenteredBox>
        );
    }

    return (
        <>
            {hasBatches || isExternalSource ? (
                <Stack direction="column" spacing={2} padding={2}>
                    {showStats ? (
                        <StatisticsPage />
                    ) : (
                        <>
                            <KeyNumbersCard openReport={handleOpenReport} onSeeMoreClick={onSeeMoreClick} />
                            <Divider variant="fullWidth" />
                            {!isExternalSource && <FilterChip />}
                            <BatchCardList />
                        </>
                    )}
                </Stack>
            ) : (
                <CenteredBox>
                    <Typography variant="h4" color="GrayText" textAlign="center">
                        {t(hasAddresses ? "select_an_address" : "no_address_match", { ns: Namespace.ADDRESSES })}
                    </Typography>
                </CenteredBox>
            )}
            
            <AddressReportModal />
        </>
    );
};

export default BatchesList;
